export default __webpack_public_path__ + "static/media/solucao-03.9eef9352.webp";